import libs from '../../libs'

const state = {
  plotting: {
    transmitter: null,
    features: [],
    index: 0,
    lastIndex: 0,
    indexed: {
      ping_time: null,
      latitude: null,
      longitude: null,
      speed: 0,
      heading: 0
    },
    mode: 'transmitter',
    track: 'stop',
    pointer: false
  }
}

const getters = {
  plotting: (state) => state.plotting
}

const actions = {
  toInitPlotting: async ({ rootState, state, commit, dispatch }) => {
    await dispatch('toLoadKapal', state.plotting.transmitter)

    const kapal = rootState.kapal.kapal

    commit('setMapControl', { mode: 'plotting' })

    if (kapal.transmitter == state.plotting.transmitter) {
      const pingTime = libs.utcFormat(kapal.ping_time, 'object')

      dispatch('toAddPlot', {
        transmitter: kapal.transmitter,
        ping_time: pingTime.datetime,
        ping_timed: pingTime,
        latitude: kapal.lat,
        longitude: kapal.lon,
        heading: kapal.heading,
        speed: kapal.speed
      })
      commit('setPlottingMode', 'import')
      dispatch('toZoom', {
        view: [
          kapal.lat,
          kapal.lon
        ]
      })
    }
  },
  toAddPlot: ({ state, commit }, plot) => {
    state.plotting.lastIndex += 1
    state.plotting.features[state.plotting.lastIndex] = plot

    commit('setPlottingIndex', {
      index: state.plotting.lastIndex,
      indexed: plot
    })
  },
  toCopyPlot: ({ state, dispatch }, plot) => {
    plot = {
      ...state.plotting.indexed,
      ...plot
    }

    plot.ping_timed.default.setTime(
      plot.ping_timed.default.getTime() + (1000 * 60 * 60)
    )

    plot.ping_timed = libs.utcFormat(plot.ping_timed.default, 'object')
    plot.ping_time = plot.ping_timed.datetime

    dispatch('toAddPlot', plot)
  },
  toNextPlot: ({ state, commit, dispatch }, index = false) => {
    if (index === false) {
      index = state.plotting.index + 1
    }

    if (state.plotting.features[index]) {
      const indexed = state.plotting.features[index]

      commit('setPlottingIndex', { index, indexed })

      dispatch('toZoom', {
        view: [indexed.latitude, indexed.longitude]
      })
    }
  },
  toPlayPlot: ({ state, commit, dispatch }) => {
    commit('setPlottingTrack', 'play')

    window.clearTimeout(window.SALMONTRACK_PLOT_TRACK)

    window.SALMONTRACK_PLOT_TRACK = window.setTimeout(() => {
      dispatch('toNextPlot', state.plotting.index + 1)

      if (state.plotting.index <= state.plotting.lastIndex) {
        dispatch('toPlayPlot')
      } else {
        dispatch('toPausePlot')
      }
    }, 1000)
  },
  toPausePlot: ({ commit }) => {
    commit('setPlottingTrack', 'pause')

    window.clearTimeout(window.SALMONTRACK_PLOT_TRACK)
  },
  toStopPlot: ({ commit, dispatch }) => {
    commit('setPlottingTrack', 'stop')
    dispatch('toNextPlot', 0)

    window.clearTimeout(window.SALMONTRACK_PLOT_TRACK)
  },
  toTogglePlot: ({ state, dispatch }) => {
    if (state.plotting.track === 'play') {
      dispatch('toPausePlot')
    } else if (state.plotting.track === 'pause') {
      dispatch('toPlayPlot')
    } else if (state.plotting.track === 'stop') {
      dispatch('toPlayPlot')
    }
  }
}

const mutations = {
  resetPlotting: (state) => {
    state.plotting = {
      transmitter: null,
      features: [],
      index: 0,
      lastIndex: 0,
      indexed: {
        ping_time: null,
        latitude: null,
        longitude: null,
        speed: 0
      },
      mode: 'transmitter',
      track: 'stop',
      pointer: false
    }
  },
  setPlottingTrack: (state, track) => {
    state.plotting.track = track
  },
  setPlotting: (state, { transmitter, features }) => {
    state.plotting.transmitter = transmitter
    state.plotting.features = features || []
    state.plotting.lastIndex = state.plotting.features.length - 1
  },
  setPlottingIndex: (state, { index, indexed }) => {
    state.plotting.index = index
    state.plotting.indexed = indexed
  },
  setPlottingTo: (state, index) => {
    state.plotting.index = index
    state.plotting.indexed = state.plotting.features[index]
  },
  setPlottingMode: (state, mode) => {
    state.plotting.mode = mode
  },
  setPlottingPointer: (state, pointer) => {
    state.plotting.pointer = pointer
  },
  setPlottingPingtime: (state, utcFormatObject) => {
    state.plotting.indexed.ping_time = utcFormatObject.datetime
    state.plotting.indexed.ping_timed = utcFormatObject
  },
  setPlottingHeading: (state, heading) => {
    state.plotting.indexed.heading = heading
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
